module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.pointsMallDia),
      expression: "!pointsMallDia"
    }]
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "关键词："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "maxlength": "10",
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "品 类："
    }
  }, [_c('el-select', {
    ref: "mySelect",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择品类"
    },
    on: {
      "change": _vm.getbrandarr
    },
    model: {
      value: (_vm.filters.brandTypeId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandTypeId", $$v)
      },
      expression: "filters.brandTypeId"
    }
  }, _vm._l((_vm.brandTypearr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "品 牌："
    }
  }, [_c('el-select', {
    ref: "mySelect1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.brandId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandId", $$v)
      },
      expression: "filters.brandId"
    }
  }, _vm._l((_vm.brandarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "状　态："
    }
  }, [_c('el-select', {
    ref: "mySelect1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  }, _vm._l((_vm.statedarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "商品类型："
    }
  }, [_c('el-select', {
    ref: "mySelect1",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择商品类型",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.type),
      callback: function($$v) {
        _vm.$set(_vm.filters, "type", $$v)
      },
      expression: "filters.type"
    }
  }, _vm._l((_vm.dada), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.value,
        "label": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("积分商城")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.goodsIsOnSale(1)
      }
    }
  }, [_vm._v(" 上 架 ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.goodsIsOnSale(0)
      }
    }
  }, [_vm._v(" 下 架 ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.eidtPointsMall(true)
      }
    }
  }, [_vm._v(" 新 增 ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.imageData,
      "stripe": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品类型",
      "prop": "typeName",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.typeName
          }
        }, [_vm._v(_vm._s(scope.row.typeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "产品型号",
      "prop": "goodModelCode",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.goodModelCode
          }
        }, [_vm._v(_vm._s(scope.row.goodModelCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.name
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属品牌商",
      "prop": "bbName",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.bbName
          }
        }, [_vm._v(_vm._s(scope.row.bbName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品类",
      "prop": "goodsBrandTypeName",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.goodsBrandTypeName
          }
        }, [_vm._v(_vm._s(scope.row.goodsBrandTypeName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brandName",
      "label": "品牌",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.brandName
          }
        }, [_vm._v(_vm._s(scope.row.brandName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "库存",
      "align": "center",
      "width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.number
          }
        }, [_vm._v(_vm._s(scope.row.number))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "换购积分",
      "prop": "integral",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.integral
          }
        }, [_vm._v(_vm._s(scope.row.integral))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "换购记录",
      "prop": "exchangeCount",
      "align": "center",
      "width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          style: ({
            color: scope.row.exchangeCount == '0' ? '#ccc' : '#6786b4',
          }),
          attrs: {
            "title": scope.row.exchangeCount
          },
          on: {
            "click": function($event) {
              return _vm.exchangeNum(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.exchangeCount))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stateName",
      "label": "状态",
      "align": "center",
      "width": "80px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: {
            red: scope.row.stateName == '过期'
          },
          attrs: {
            "title": scope.row.stateName
          }
        }, [_vm._v("\r\n                " + _vm._s(scope.row.stateName) + "\r\n              ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "240px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "action_container"
        }, [(scope.row.state != 1) ? _c('p', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.eidtPointsMall(false, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑\r\n                ")]) : _vm._e(), _vm._v(" "), _c('p', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.upordown(1, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v("向上\r\n                ")]), _vm._v(" "), _c('p', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.upordown(2, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v("向下\r\n                ")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), (_vm.pointsMallDia) ? _c('div', {
    staticClass: "main_container"
  }, [_c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v(" 新增/编辑商品 ")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "margin": "5px 10px 0 0"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.cancelAdd()
      }
    }
  }, [_vm._v("关闭")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "90%",
      "margin": "30px auto"
    }
  }, [_c('el-form', {
    ref: "addGoodsForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.addGoodsForm,
      "label-width": "100px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属城市:",
      "prop": "preCity"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.options,
      "placeholder": "请选择所属城市",
      "filterable": "",
      "clearable": "",
      "disabled": !_vm.pointsType
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.addGoodsForm.preCity),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "preCity", $$v)
      },
      expression: "addGoodsForm.preCity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品类型:",
      "prop": "type"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": !_vm.pointsType
    },
    on: {
      "change": _vm.radioType
    },
    model: {
      value: (_vm.addGoodsForm.type),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "type", $$v)
      },
      expression: "addGoodsForm.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("商品")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("优惠券")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("现金礼包")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.addGoodsForm.type) ? [(_vm.addGoodsForm.type == 1) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changeDp
    },
    model: {
      value: (_vm.addGoodsForm.dianpu),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "dianpu", $$v)
      },
      expression: "addGoodsForm.dianpu"
    }
  }, _vm._l((_vm.dianpuOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品类:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changepl
    },
    model: {
      value: (_vm.addGoodsForm.dlpl),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "dlpl", $$v)
      },
      expression: "addGoodsForm.dlpl"
    }
  }, _vm._l((_vm.dlplOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.changepp
    },
    model: {
      value: (_vm.addGoodsForm.dlpp),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "dlpp", $$v)
      },
      expression: "addGoodsForm.dlpp"
    }
  }, _vm._l((_vm.dlppOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addGoodsForm.shangpin),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "shangpin", $$v)
      },
      expression: "addGoodsForm.shangpin"
    }
  }, _vm._l((_vm.shangpinOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addGoodsForm.type == 2) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "优惠券:",
      "prop": "couponId"
    }
  }, [_c('el-cascader', {
    key: _vm.couponKey,
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.couponsList,
      "disabled": !_vm.pointsType,
      "props": _vm.optionCouponProps,
      "placeholder": "请选择优惠券",
      "filterable": "",
      "clearable": "",
      "popper-class": "maxCascaderWidth"
    },
    on: {
      "change": _vm.handleCouponsChange
    },
    model: {
      value: (_vm.addGoodsForm.couponId),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "couponId", $$v)
      },
      expression: "addGoodsForm.couponId"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.addGoodsForm.type == 3) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "现金礼包面值:",
      "prop": "faceValue"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入金额（元）",
      "maxlength": "10",
      "width": "100%",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.addGoodsForm.faceValue),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "faceValue", $$v)
      },
      expression: "addGoodsForm.faceValue"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "可兑换数量:",
      "prop": "number"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入数量",
      "maxlength": "7",
      "width": "100%",
      "oninput": "value=value.replace(/[^\\d]/g,'')",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.addGoodsForm.number),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "number", $$v)
      },
      expression: "addGoodsForm.number"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "需要的积分:",
      "prop": "integral"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入需要的积分",
      "maxlength": "7",
      "width": "100%",
      "oninput": "value=value.replace(/[^\\d]/g,'')",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    on: {
      "blur": function (value) {
        _vm.getVal(value, 'integral');
      }
    },
    model: {
      value: (_vm.addGoodsForm.integral),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "integral", $$v)
      },
      expression: "addGoodsForm.integral"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label": "+",
      "prop": "price",
      "label-width": "35px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入需要的价格",
      "maxlength": "10",
      "width": "100%",
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.addGoodsForm.price),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "price", $$v)
      },
      expression: "addGoodsForm.price"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.addGoodsForm.type == 1) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "送货方式:",
      "prop": "deliveryMode"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": _vm.deliveryTypeChange
    },
    model: {
      value: (_vm.addGoodsForm.deliveryMode),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "deliveryMode", $$v)
      },
      expression: "addGoodsForm.deliveryMode"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("快递送货 \r\n                      "), _c('el-input', {
    attrs: {
      "placeholder": "请输入运费，免运费输入0即可",
      "maxlength": "10",
      "width": "100%",
      "disabled": _vm.addGoodsForm.deliveryMode == 2,
      "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
    },
    model: {
      value: (_vm.addGoodsForm.freight),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "freight", $$v)
      },
      expression: "addGoodsForm.freight"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("客户到店自取 \r\n                      "), _c('el-input', {
    attrs: {
      "placeholder": "请输取货地址",
      "maxlength": "50",
      "disabled": _vm.addGoodsForm.deliveryMode == 1,
      "width": "100%"
    },
    model: {
      value: (_vm.addGoodsForm.address),
      callback: function($$v) {
        _vm.$set(_vm.addGoodsForm, "address", $$v)
      },
      expression: "addGoodsForm.address"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "说明:",
      "prop": "explain"
    }
  }, [_c('wjEditor', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "desc": _vm.addGoodsForm.explain
    },
    on: {
      "change": _vm.contentChangeOne
    }
  })], 1)], 1)], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelAdd
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.saveAddGoods('addGoodsForm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": _vm.exchangeRecordTitle,
      "custom-class": "registrationRecord",
      "visible": _vm.exchangeRecord,
      "direction": "rtl",
      "size": "35%"
    },
    on: {
      "update:visible": function($event) {
        _vm.exchangeRecord = $event
      }
    }
  }, [_c('div', {
    staticClass: "dataDescription"
  }, [_c('span', [_vm._v("总换购记录："), _c('b', [_vm._v(_vm._s(_vm.activeOrderTotal))])])]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.exchangeRecordList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "userName",
      "label": "用户昵称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "userPhone",
      "label": "手机号",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "integral",
      "label": "消费积分数量",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "cTime",
      "width": "160px",
      "label": "支付时间",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.activeOrderPageIndex,
      "total": _vm.activeOrderTotal
    },
    on: {
      "current-change": _vm.handleCurrentChangehddd
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-211119ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PointsMall/PointsMallList.vue
// module id = 1654
// module chunks = 3